import { render, staticRenderFns } from "./summary-subtitle.vue?vue&type=template&id=3dc4c5bc&scoped=true"
import script from "./summary-subtitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./summary-subtitle.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./summary-subtitle.vue?vue&type=style&index=0&id=3dc4c5bc&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc4c5bc",
  null
  
)

export default component.exports